export default {
  props: {
    dispatchAction: String,
    payload: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    downloadFile() {
      this.isLoading = true
      this.$store
        .dispatch(this.dispatchAction, this.payload)
        .then(supervisorListResponse => {
          let checking = false
          const intVal = setInterval(() => {
            if (!checking) {
              checking = true
              this.$store
                .dispatch('staticModule/checkTaskStatus', supervisorListResponse.data)
                .then(res => {
                  const { data } = res
                  if (data.status === 'SUCCESS') {
                    clearInterval(intVal)
                    const link = document.createElement('a')
                    link.href = data.file_url
                    link.setAttribute('download', true)
                    document.body.appendChild(link)
                    link.click()
                    this.isLoading = false
                  } else {
                    checking = false
                  }
                }).catch(() => {
                  clearInterval(intVal)
                  this.isLoading = false
                })
            }
          }, 5000)
        })
        .catch(() => {
          this.isLoading = false
        })
    },
  },
  setup() {
    const { VUE_APP_BACKEND_BASE_URL } = process.env
    return {
      VUE_APP_BACKEND_BASE_URL,
    }
  },
}
